import React, { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { Table, UncontrolledTooltip } from 'reactstrap'
import moment from 'moment'
import gql from 'graphql-tag'

import PrimaryListingContainer from "../../Material/PrimaryListingContainer"
import CarModelGroupIcon from '../../CA/CarModelGroupIcon'
import toTitleCase from '../../Functions/toTitleCase'
import CarInfoModal from '../../CA/CarInfoModal'
import renderEnumToInt from '../../Functions/renderEnumToInt'
import { JobStatuses } from '../../Functions/querys'
import { ReactComponent as LocationIcon } from '../../assets/images/icons/location-icon.svg'
import '../CarIssue.css'
import "../../Material/ListingHeader.css"

import withApolloClient from '../../withApolloClient'

const CarJobQuery = gql`query CarJobQuery($cursor: String, $searchTerm: String, $stageIn:[Int], $vendorIn:[ID], $jobTypeIn:[ID], $statusIn:[Int], $orderBy: [String], $first:Int, $startDate:Date, $endDate:Date) {
    allJobs(first:$first, orderBy:$orderBy, after: $cursor, searchTerm:$searchTerm, stageIn:$stageIn, vendorIn:$vendorIn, jobTypeIn:$jobTypeIn, statusIn:$statusIn, startDate:$startDate, endDate:$endDate){
        edges {
            node {
              id
              dateAdded
              jobDate
              status
              notes
              totalPrice
              partsQuantity
              customId
              runner
              runnerRep {
                id
                username
                firstName
                lastName
              }
              driver{
                  id
                  name
              }
              jobType {
                id
                name
              }
              updatedBy{
                id
                username
                firstName
                lastName
              }
              car {
                id
                pk
                year
                make
                model
                modelSeries
                location
                color
                group
                notes
                stage
                stageDisplay
                carpolicySet {
                  edges {
                    node {
                      id
                      status
                      insurancePolicy {
                        id
                        startDate
                        endDate
                        status
                        policyNumber
                        broker {
                          id
                          name
                        }
                      }
                    }
                  }
                }
                currentAgreement {
                  driver {
                    id
                    tlcLicense
                    name
                  }
                }
              }
              vendor {
                id
                name
              }
            }
        }
        pageInfo{
            endCursor
            hasNextPage
        }
    } 
}`

const tableHeaders = [
    { id: "job", name: "Job Details", sortable: false }, { id: "id", name: "Car", sortable: true },
    { id: "notes", name: "Job Notes", sortable: false }, { id: "action", name: "Actions", sortable: false }
]

class JobsList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            location: null,
            loading: false,
            error: "",
        }
    }
    toggleModal = (modalName) => {
        if (this.state.openModal === modalName) {
            this.setState({ openModal: "" })
        } else {
            this.setState({ openModal: modalName })
        }
    }


    render() {
        return (
            <PrimaryListingContainer listLoading={this.props.loading} loadMoreEntries={this.props.allJobs && this.props.allJobs.pageInfo && this.props.allJobs.pageInfo.hasNextPage ? this.props.loadMoreEntries : null} refetchListQuery={this.props.refetchQuery}>
                <Table responsive>
                    <thead>
                        <tr>
                            <th onClick={this.toggleSelectAllClick} style={{ cursor: "pointer" }}> {this.state.selectAll ? <i className="fa fa-plus-square" aria-hidden="true"></i> : <i className="fa fa-square-o" aria-hidden="true"></i>}</th>
                            {tableHeaders.map(tableHeader => tableHeader.sortable ?
                                <th key={tableHeader.id} onClick={() => this.props.updateOrder(tableHeader.id)} style={{ cursor: "pointer" }}>{tableHeader.name}</th> :
                                <th key={tableHeader.id}>{tableHeader.name}</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.allJobs && this.props.allJobs.edges && this.props.allJobs.edges.length > 0 ? this.props.allJobs.edges.map((job, i) =>
                            <tr>
                                <td scope="row">{i + 1}</td>
                                <td>
                                    <div className="bos-table-td-left-box">
                                        <i className="fa fa-wrench" aria-hidden="true"></i>
                                    </div>

                                    <div className="bos-table-td-right-box">
                                        <small>
                                            <span id={"runner" + i}>{job.node.runner ? (job.node.runner === "REP" ? (job.node.runnerRep ? job.node.runnerRep.firstName ? job.node.runnerRep.firstName + " " + job.node.runnerRep.lastName : job.node.runnerRep.username : "REP") : (job.node.driver ? job.node.driver.name : "DRIVER")) : "--"}</span> | {job.node.dateAdded ? moment(job.node.dateAdded).tz("America/New_York").format('ll') : "--"} | {this.props.jobStatuses?.states?.find(item => item.name === job.node.status)?.description || job.node.status}
                                            <UncontrolledTooltip placement="right" target={"runner" + i}>Job Runner - {job.node.runner}</UncontrolledTooltip>
                                        </small>
                                        <div><b>{job.node.jobType ? job.node.jobType.name : "--"} | {job.node.vendor ? job.node.vendor.name : "--"}</b></div>
                                        <small>
                                            ${job.node.totalPrice} | <span id={"customId" + i}>{job.node.customId}</span> | <span id={"updatedBy" + i}>{job.node.updatedBy ? job.node.updatedBy.firstName ? job.node.updatedBy.firstName + " " + job.node.updatedBy.lastName : job.node.updatedBy.username : "--"}</span>
                                            <UncontrolledTooltip placement="right" target={"customId" + i}>Custom ID</UncontrolledTooltip>
                                            <UncontrolledTooltip placement="right" target={"updatedBy" + i}>Last Updated By</UncontrolledTooltip>
                                        </small>
                                    </div>
                                    <div className='bos-table-td-right-box-actions-wrapper'>
                                        <ul className="bos-table-td-right-box-actions">
                                            {job.node.status && job.node.status === "A_2" && <li>
                                                <i className="fa fa-check" aria-hidden="true" style={{ color: "#2acd72" }}></i>
                                            </li>}
                                        </ul>
                                    </div>
                                </td>
                                <td className="py-3">
                                    <div className="cars-wrapper">
                                        <div className="bos-table-td-left-box">
                                            {this.state.openModal === "CarInfo" + job.node.car.pk && <CarInfoModal handleClose={() => this.toggleModal("")} open={this.state.openModal === "CarInfo" + job.node.car.pk} id={job.node.car.pk} carPk={job.node.car.pk} carId={job.node.car.id} isFleetManagement={this.props.isFleetManagement} refetchQuery={this.props.refetchQuery} />}
                                            <small>{job.node.car.pk}</small>
                                            <br />
                                            <a onClick={() => this.toggleModal("CarInfo" + job.node.car.pk)} style={{ cursor: "pointer" }}>
                                                {/* <i className="fa fa-cog" style={{fontSize: "22px"}} aria-hidden="true"></i> */}
                                                <CarModelGroupIcon carGroup={job.node.car.group} carColor={job.node.car.color} id={job.node.car.pk} key={i + 1} />
                                            </a>
                                            <br />
                                            <small>Stage {job.node.car?.stageDisplay}</small>
                                        </div>

                                        <div className="bos-table-td-right-box">
                                            <span>
                                                <small>{job.node.car.year} | {job.node.car.color} {job.node.car.group ? "| " + job.node.car.group : ""}</small>
                                            </span>
                                            <div className="car-name">
                                                <a className="bos-custom-link" href={"/car/" + job.node.car.pk} target="_blank">
                                                    {toTitleCase(job.node.car.make)} {toTitleCase(job.node.car.model)}
                                                </a>&nbsp;
                                                <small>{job.node.car.modelSeries ? "(" + job.node.car.modelSeries + ")" : ""}</small>
                                                {(renderEnumToInt(job.node.car.stage) === 10 || (job.node.car.currentAgreement && job.node.car.currentAgreement.id)) && <>
                                                    <i id={"driverIsActive" + i} className="ml-2 fa fa-circle text-success" ></i>
                                                    <UncontrolledTooltip placement="right" target={"driverIsActive" + i}>Active Car</UncontrolledTooltip>
                                                </>}
                                            </div>
                                            <small>
                                                {job.node.car.carpolicySet && job.node.car.carpolicySet.edges && job.node.car.carpolicySet.edges.length > 0 &&
                                                    job.node.car.carpolicySet.edges.filter(policy => policy.node.insurancePolicy && policy.node.status === 'A_1').length > 0 ?
                                                    job.node.car.carpolicySet.edges.filter(policy => policy.node.insurancePolicy && policy.node.status === 'A_1')[0].node.insurancePolicy.policyNumber
                                                    : "No Insurance Found!"}
                                            </small>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="notes">
                                        <span id={"issueNotesEdit" + i}>
                                            <small className="note-text">
                                                {job.node.notes ? job.node.notes : "--"}
                                            </small>
                                            <UncontrolledTooltip placement="top" target={"issueNotesEdit" + i}>{job.node.notes ? job.node.notes : "--"}</UncontrolledTooltip>
                                        </span>
                                    </div>
                                </td>
                                <td>
                                    <ul className="actions pt-3 pl-0">
                                        <li>
                                            <a id={"LocationPopup" + i} href={`${process.env.REACT_APP_FLEETSYNC_URL}/cars/${job.node.car.pk}?tab=Map`} target={"_blank"} rel="noopener noreferrer">
                                                <LocationIcon width="20" fill="#303E67" />
                                            </a>
                                            <UncontrolledTooltip placement="top" target={"LocationPopup" + i} >
                                                Locate car on fleetSync
                                            </UncontrolledTooltip>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        ) : !this.props.loading && <tr>
                            <td colSpan={10}>No Cars Found!</td>
                        </tr>}
                    </tbody>
                </Table>
            </PrimaryListingContainer>

        )
    }
}


//-----------------------------------
export default (
    graphql(JobStatuses, {
        options: { fetchPolicy: 'cache-first' },
        props: ({ data: { loading, jobStatuses } }) => ({
            loading, jobStatuses
        })
    })(
        graphql(CarJobQuery, {
            options: ({ searchTerm, orderBy, stageIn, jobTypeIn, statusIn, vendorIn, startDate, endDate }) => ({
                variables: { searchTerm, orderBy, stageIn, jobTypeIn, statusIn, first: 30, vendorIn, startDate, endDate },
                notifyOnNetworkStatusChange: true, fetchPolicy: 'network-only'
            }),
            props: ({ data: { loading, allJobs, fetchMore, variables } }) => ({
                loading,
                allJobs,
                variables,
                refetchQuery: () => {
                    let currentLength = allJobs && allJobs.edges ? allJobs.edges.length : 30
                    return fetchMore({
                        query: CarJobQuery,
                        variables: {
                            ...variables,
                            first: currentLength,
                        },
                        updateQuery: (previousResult, { fetchMoreResult }) => {
                            const newEdges = fetchMoreResult.allJobs.edges
                            const pageInfo = fetchMoreResult.allJobs.pageInfo
                            return {
                                allJobs: {
                                    edges: [...newEdges],
                                    pageInfo,
                                    searchTerm: previousResult.searchTerm,
                                    __typename: previousResult.allJobs.__typename
                                },
                            }
                        },
                    })
                },
                loadMoreEntries: () => {
                    return fetchMore({
                        query: CarJobQuery,
                        variables: {
                            cursor: allJobs.pageInfo.endCursor,
                            ...variables
                        },
                        updateQuery: (previousResult, { fetchMoreResult }) => {
                            const newEdges = fetchMoreResult.allJobs.edges
                            const pageInfo = fetchMoreResult.allJobs.pageInfo
                            return {
                                allJobs: {
                                    edges: [...previousResult.allJobs.edges, ...newEdges],
                                    pageInfo,
                                    searchTerm: previousResult.searchTerm,
                                    stageIn: previousResult.stageIn,
                                    jobTypeIn: previousResult.jobTypeIn,
                                    statusIn: previousResult.statusIn,
                                    vendorIn: previousResult.vendorIn,
                                    __typename: previousResult.allJobs.__typename
                                },
                            }
                        },
                    })
                },
            })
        })(
            withApolloClient(JobsList)
        )
    )
)
